export const originalTypes = {
  delivery: {
    stopType: 2,
    stopTypeDescription: 'D',
  },
  collection: {
    stopType: 5,
    stopTypeDescription: 'C',
  },
  break: {
    stopType: 3,
    stopTypeDescription: 'B',
  },
  pickup: {
    stopType: 4,
    stopTypeDescription: 'P',
  },
  precise: {
    stopType: 6,
    stopTypeDescription: 'T',
  },
};

export const pickupKindTypes = {
  shop: 'SHP',
  locker: 'LKR',
};

export const pickupKindTypesLabels = {
  [pickupKindTypes.shop]: 'Shop',
  [pickupKindTypes.locker]: 'Locker',
};

export default {
  delivery: 'D',
  break: 'B',
  collection: 'C',
  shop: 'P',
  precise: 'T',
  pickupCollection: 'PC',
};
